export var SIMPLE_OVERLAY_ELEMENT = 'simple-overlay';
export var PATIENT_LABEL_ELEMENT = 'patient-label-element';
export var ELEMENT_GRID_ID = 'grid-ref';
